import { useEffect } from "react"

export default function Faq() {
    useEffect(() => {
        window.location.replace("https://lucaplus.zendesk.com/hc/en-us")
    }, [])
    return null
}
